<script>
  import { afterUpdate } from "svelte";
  import moment from "moment";

  export let value,
    unit = "minutes";

  let result;
  afterUpdate(() => {
    result = moment
      .utc(moment.duration(value, unit).asMilliseconds())
      .format("HH:mm:ss");
  });
</script>

<span>{result}</span>
